<template>
  <v-dialog v-model="dialog" max-width="450px">
    <template v-slot:activator="{ on }">
      <span v-on="on" class="d-inline-block">
        <add-button class="px-6">Add Manual Dispute</add-button>
      </span>
    </template>
    <dialog-card
      @close="dialog = false"
      title="Select Template"
      :is-submit="false"
    >
      <div class="d-flex flex-column pt-2 pb-1">
        <v-btn
          v-for="item in items"
          :key="item.key"
          class="mb-3 justify-start px-4"
          color="primary"
          outlined
          block
          height="40px"
          @click="open(item.key)"
        >
          {{ item.name }}
        </v-btn>
      </div>
    </dialog-card>
  </v-dialog>
</template>

<script>
import AddButton from "../ui/buttons/AddButton.vue";
import DialogCard from "../ui/DialogCard.vue";
import {IDTR_TEMPLATES} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {AddButton, DialogCard},
  data() {
    return {
      dialog: false,
      items: IDTR_TEMPLATES,
    };
  },
  methods: {
    open(template) {
      this.dialog = false;
      this.$router.push({name: "identity-theft-report", params: {template}});
    },
  },
};
</script>
